import RegisterDataBackOffice from './register-form';

export default RegisterDataBackOffice;
